import React from 'react';
import PropTypes from 'prop-types';

import Step from './Step';

import theme from './Stepper.scss';

const propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    isStepDisable: PropTypes.bool.isRequired,
    isStepComplete: PropTypes.bool.isRequired,
    titleMessage: PropTypes.object.isRequired,
  })).isRequired,
  currentStep: PropTypes.number.isRequired,
  onStepClick: PropTypes.func.isRequired,
};

const Stepper = ({ options, currentStep, onStepClick }) => (
  <div className={ theme.root }>
    { options && options.map((option, index) => (
      <Step
        { ...option }
        isStepActive={ currentStep === index + 1 }
        stepId={ index + 1 }
        onStepClick={ () => onStepClick(index + 1) }
        key={ `step-${ index + 1 }` }
      />
    )) }
  </div>
);

Stepper.propTypes = propTypes;

export default Stepper;
